import { Eye, X } from 'lucide-react'
import { useEditContext } from '@/contexts/EditContext'
import { cn } from '@/lib/utils'

export function PreviewBanner() {
  const { isPreviewMode } = useEditContext()

  if (!isPreviewMode) return null

  const handleExit = () => {
    // Remove ?preview from URL
    const url = new URL(window.location.href)
    url.searchParams.delete('preview')
    window.location.href = url.toString()
  }

  return (
    <div
      className={cn(
        'fixed top-0 left-0 right-0 z-50',
        'bg-amber-500 text-amber-950',
        'px-4 py-2'
      )}
    >
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="w-4 h-4" />
          <span className="text-sm font-medium">
            Mode apercu - Vous visualisez le brouillon
          </span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-1 text-sm hover:underline"
        >
          <X className="w-4 h-4" />
          Quitter l'apercu
        </button>
      </div>
    </div>
  )
}
